// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aKmJx","content":"styles_content__2VIKV"};